import { Api } from '@/services/Api'
import store from "@/store/index";
const momentTz = require('moment-timezone')

export default {
  getOverallHeader(plantId) {
    return Api().get(`/api/v2/inverter-ranking/overall-performance/${plantId}`)
  },
  getRankingHeader(plantId, parameter) {
    return Api().get(`/api/v2/inverter-ranking/ranking-trend/${plantId}/${parameter}`)
  },
  getPrPerformance(plantId) {
    return Api().get(`/api/v2/inverter-ranking/best-pr/${plantId}`)
  },
  getTableData(param) {
    return Api().post(`/api/v2/inverter-ranking/table`, param)
  },
  getHeatMapRank(param) {
    return Api().post(`/api/v2/inverter-ranking/heatmap`, param)
  },
  downloadReport(param, name) {
    return Api().request({
      url: '/api/v2/inverter-ranking/download/' + param,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const tz = store.getters.getGeneralState('activePlant').timezone
      const filename = `${name}-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  }
}
